// extracted by mini-css-extract-plugin
export var infoItem = "_qb-2";
export var title = "_qb-0";
export var value = "_qb-1";